import {
  FETCH_EDI_REQUEST_RECORD_REQUEST,
  FETCH_EDI_REQUEST_RECORD_SUCCESS,
  FETCH_EDI_REQUEST_RECORD_FAILURE,
  FETCH_EDI_FORMAT,
  SET_EDI_FORMAT,
  SET_POPUP_FLAG,
  SET_POPUP_RECORDS,
} from "../actionTypes";

import edireqrecord from "../service/cbp";

const fetchEdiRequestRecords = () => {
  return {
    type: FETCH_EDI_REQUEST_RECORD_REQUEST,
  };
};

const fetchEdiReqRecordSuccess = (edidata) => {
  return {
    type: FETCH_EDI_REQUEST_RECORD_SUCCESS,
    payload: edidata,
  };
};

const fetchEdiReqRecordfailure = (error) => {
  return {
    type: FETCH_EDI_REQUEST_RECORD_FAILURE,
    payload: error,
  };
};
export const setFlagforPopup = (flag) => {
  return {
    type: SET_POPUP_FLAG,
    payload: flag,
  };
};

const setEdiFormatRecords = (payload, res) => {
  return {
    type: SET_EDI_FORMAT,
    payload: payload,
  };
};

export const setPopupRecords = (data) => {
  return {
    type: SET_POPUP_RECORDS,
    payload: data,
  };
};

export const fetchEdiReqRecords = (
  requestid,
  country,
  generateEDI,
  type,
  shipmentid,
  selectedRow = null
) => {
  return (dispatch) => {
    // edireqrecord
    //   .fetchEdiFormat(payload)
    //   .then((res) => {
    //     payload.response = res.entries ?? {};
    //     dispatch(setEdiFormatRecords(payload));
    //   })

    // .then(() => {
    dispatch(fetchEdiRequestRecords());
    edireqrecord
      .getRequestRecords(
        requestid,
        country,
        generateEDI,
        type,
        shipmentid,
        selectedRow
      )
      .then((response) => {
        const ediReqRecords = response.data;
        dispatch(fetchEdiReqRecordSuccess(ediReqRecords));
      })
      .catch((error) => {
        const errorMessage = error.message;
        dispatch(fetchEdiReqRecordfailure(errorMessage));
      });
    // });
  };
};
